import { MkPattern } from "../lib/type-utils";
import { NewsItem } from "./news";
import { Person, Sponsor } from "./people";

// -----------------------------------------------------------------------------
// Page

export interface PageMeta {
  /* From the refinery_page_translations database table */
  title: string;
  /* From the seo_meta database table */
  subtitle?: string;
  /* From the seo_meta database table */
  meta_description?: string;

  intro?: string;
  quote?: string;
  content?: string;
  aside?: string;
}

export interface DefaultPage {
  _tag: "default";
  meta: PageMeta;
}

export interface AboutPage {
  _tag: "about";
  meta: PageMeta;
  boardMembers: Array<Person>;
  teamMembers: Array<Person>;
  sponsors: Array<Sponsor>;
}

export interface ContactPage {
  _tag: "contact";
  meta: PageMeta;
}

export interface NewsPage {
  _tag: "news";
  meta: PageMeta;
  newsItems: Array<NewsItem>;
}

export interface OrganizationsPage {
  _tag: "organizations";
  meta: PageMeta;
}

export type Page = DefaultPage | AboutPage | ContactPage | NewsPage | OrganizationsPage;

export const foldPage =
  <A>(pattern: MkPattern<Page, "_tag", A>) =>
  (x: Page): A =>
    (pattern[x._tag] as any)(x); // eslint-disable-line @typescript-eslint/no-explicit-any

export const foldPage_ = <A>(x: Page, pattern: MkPattern<Page, "_tag", A>) => foldPage(pattern)(x);

// -----------------------------------------------------------------------------
// PageType

export type PageType = Page["_tag"];

export const foldPageType =
  <A>(pattern: Record<PageType, () => A>) =>
  (x: PageType) =>
    pattern[x]();

export const foldPageType_ = <A>(x: PageType, pattern: Record<PageType, () => A>) => foldPageType(pattern)(x);

export function pageTypeFromRoute(route: string): PageType {
  return route.match(/\/ueber-uns/)
    ? "about"
    : route.match(/\/kontakt/)
      ? "contact"
      : route.match(/\/service/)
        ? "news"
        : route.match(/\/news/)
          ? "news"
          : route.match(/\/atlas/)
            ? "organizations"
            : "default";
}
